import React from 'react';
import Carousel from '../carousel/carousel';
import TableTd from './TableTd';
import $ from 'jquery'
import HomeIcon from '../common/HomeIcon';
import Mantra1_3 from '../Mantra1/mantra1_3';
import Mantra33_canvas from './mantra33_canvas';
import { Html2CanvasFunction } from '../../utils/NewHelper';
import { showCongratulations } from "../../utils/misc";
import {
    dataURLToBlob,
    onImageFileUploaded,
    translation,
} from "../../utils/helper";
import Loader from '../loader/loader';
var EXIF = require("exif-js/exif.js");


let obj = {}

class Mantra33_2 extends React.Component {
    constructor() {
        super()
        this.state = {
            cropper: null,
            count: 0,
            isLoading: false,
            image: null,
            croppedImageOutput: '/assets/img/userdefault.png',
            table: {
                "No": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], "PARAMETERS": ['Approachable', 'Cool quotient', 'Sporty', 'Compassionate',
                    'Patient', 'Calm in Crisis', 'Fun-loving', 'Positivity', 'Tech Awareness', 'Role Model'], "RATING": [10, 10, 10, 10, 10, 10, 10, 10, 10, 10]
            }
        }
    }

    count = (index, index1) => {
        let count = $('.star_rating li.forcount').length;

        obj[index1] = index;
        $('.count_update').html(count);
        this.setState({
            count: count
        })

    }
    readFile = (e) => {
        var ref = this;
        var input = e.target;
        e.persist();
        if (!$(".loaderMain").is(":visible")) {
            $(".loaderMain").fadeIn();
        }
        if (this.state.userData == null && false) {
            setTimeout(function () {
                ref.readFile(e);
            }, 1000);

            return false;
        }

        if (input.files && input.files[0]) {
            var reader = new FileReader();
            reader.onload = function (e) {
                var image = new Image();
                var input_src = e.target.result;

                image.onload = function (imageEvent) {
                    var orientation_do = 0;
                    EXIF.getData(image, function () {
                        var orientation = EXIF.getTag(this, "Orientation");
                        if (typeof orientation != "undefined") {
                            orientation_do = orientation;
                        }
                    });

                    // Resize the image
                    var canvas = document.createElement("canvas"),
                        max_size = 1200, // TODO : pull max size from a site config
                        width = image.width,
                        height = image.height;
                    if (width > height) {
                        if (width > max_size) {
                            height *= max_size / width;
                            width = max_size;
                        }
                    } else {
                        if (height > max_size) {
                            width *= max_size / height;
                            height = max_size;
                        }
                    }
                    // alert(orientation_do);
                    if (orientation_do == 6 || orientation_do == 8) {
                        canvas.width = height;
                        canvas.height = width;
                    } else {
                        canvas.width = width;
                        canvas.height = height;
                    }

                    var ctx = canvas.getContext("2d");

                    ctx.drawImage(image, 0, 0, width, height);

                    if (canvas.width > canvas.height) {
                        ref.setState({ orientation: "frame_1" }); //landscape
                    } else {
                        ref.setState({ orientation: "frame_2" }); //portrait
                    }

                    var dataUrl = canvas.toDataURL("image/jpeg");

                    var resizedImage = dataURLToBlob(dataUrl);
                    ref.setState({
                        image: URL.createObjectURL(resizedImage),
                        cropper: true,
                        resizedImage: resizedImage,
                        windowHeight: $(window).height(),
                        croppedImage: null,
                        currentSection: "SectionCrop",
                    });
                    // ref.handleChange(); // for validation
                };

                image.src = input_src;
            };

            reader.readAsDataURL(input.files[0]);
            //now we initiate upload without showing any loading to user
        }
    };

    setCroppedImage(croppedImage) {
        this.setState({ croppedImageOutput: croppedImage, cropper: false }, () => {
            // this.postData();
        });
        // this.handleChange();
    }


    hideCropper = () => {
        this.setState({
            cropper: false,
        });
    };

    postData = async () => {
        // e.preventDefault();
        this.setState({
            isLoading: true
        })

        if (obj && Object.keys(obj).length > 0 && this.state.croppedImageOutput) {

            //canvas this means canvas is all set, read the name and festival and generate canvas now
            $(".preloader_mantra").show();
            var ref = this;
            let reqdata = {
                type: ref.props.type,
                module_name: ref.props.module_name
            }
            let resData = await Html2CanvasFunction(reqdata)
            resData.addEventListener("load", function (data) {
                data = resData.response;
                data = JSON.parse(data);
                var imageUrl = data.data.cardimage;
                var id = data.data.id;
                ref.setState({
                    "shareData": imageUrl,
                    "id": id, "image": null,
                    isLoading: false
                }, () => {
                    showCongratulations(ref.props.module_name)
                });

                ref.props.onCanVase(imageUrl, id)
                // ref.processShare(data, params, ref);
                onImageFileUploaded({
                    image: imageUrl,
                    module: ref.props.module_name,
                    postid: id
                });

            });
        } else {
            alert("Please Upload photo and select rating.")
            this.setState({
                isLoading: false
            })
        }
    }

    setText = (e, index1) => {
        const { table } = this.state;
        let gf = table['PARAMETERS'];
        gf[index1] = e.target.value;

        this.setState({ table })

    }


    render() {
        const { table, cropper, image, isLoading, croppedImageOutput, count } = this.state;
        let keys = Object.keys(table);
        if (isLoading) {
            return (
                <Loader />
            )
        }
        return (
            <div>
                {/* <Carousel /> */}
                {/* <img src="/assets/img/home.png" className="img-fluid mantr6_img" alt="" /> */}
                <HomeIcon goToFormBack={this.props.bckBttn} backToForm={this.props.backToForm} />
                <div className="container">
                    <div className="mantra33_upload_div">
                        <img src={this.state.croppedImageOutput} className="img-fluid d-block mx-auto user_img" alt="" />
                        <img src="/assets/img/multistar.png" className="img-fluid multistar_img" alt="" />
                        <div className="inpu_m33">
                            <img src="/assets/img/camera.png" className="img-fluid change_img" alt="" />
                            <input type="file" ref={(fileReader) => {
                                this.fileReader = fileReader;
                            }}
                                onChange={this.readFile} />
                        </div>

                    </div>
                    <div className="upload_heading">
                        <h5>Upload your parent’s photo</h5>
                    </div>



                    <table className="table table-bordered table_class">
                        <thead>
                            <tr>
                                <th className="serail_bg">No</th>
                                <th className="parameter_bg">PARAMETERS</th>
                                <th className="rating_bg">RATING</th>
                            </tr>
                        </thead>
                        <tbody>
                            {

                                table['No'] && (table['No']).length > 0 && (table['No']).map((val, index1) => {

                                    return (
                                        <tr>
                                            <td>{table['No'][(index1)]}</td>
                                            <td><input onChange={(e) => { this.setText(e, index1); }} type="text" defaultValue={table['PARAMETERS'][(index1)]} /></td>
                                            <td>
                                                <ul className={"star_rating star_" + (index1 + 1)}>
                                                    <TableTd star={table['RATING'][index1]} count={this.count} index1={index1} />
                                                </ul>
                                            </td>
                                        </tr>
                                    )
                                })

                            }

                        </tbody>
                    </table>
                    {cropper && (
                        <Mantra1_3 image={this.state.image}
                            setCroppedImage={this.setCroppedImage.bind(this)}
                            hideCropper={this.hideCropper} />
                    )}
                    {
                        obj && Object.keys(obj).length > 0 && croppedImageOutput &&
                        <Mantra33_canvas table={table} module_name={this.props.module_name} count={count} image={croppedImageOutput} obj={obj} />
                    }

                    <div className="total_score">
                        <h6>TOTAL SCORE <span className={"count_update"}>0</span>/100</h6>
                    </div>

                    <div className="preview_btn">
                        <button type="button" className="share2_btn" onClick={() => this.postData()}>Done</button>
                    </div>


                </div>

            </div>

        )
    }
}

export default Mantra33_2;